import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSatelliteDish, faSyncAlt, faBars, faPlusCircle, faPrint } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import { ToastContainer, toast } from "react-toastify";
import Toggle from "react-toggle";
import 'react-toastify/dist/ReactToastify.min.css';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import moment from "moment";

import LocalStorageService from "../../../../../../services/LocalStorageService";
import LocalDbService from "../../../../../../services/LocalDbService";
import CoreService from "../../../../../../services/CoreService";
import ConfigService from "../../../../../../services/ConfigService";


import ModalGridMenu from "./ModalGridMenu.jsx";

import ReceiptVoidEvent from "../../../../../../models/ReceiptVoidEvent";
import {MsaReceiptStatusType} from "../../../../../../models/MsaReceiptStatusType"



export default class GridPanel extends Component {
  constructor(props) {
    super(props);

    this.localStorageService = new LocalStorageService();
    this.coreService = new CoreService();
    this.localDbService = new LocalDbService();
    this.configService = new ConfigService();

    this.syncTimer = null;
    this.delayInterval = this.configService.getReceiptStatusInterval();


    this.state =
    {
      gridSchema: null,
      gridData: null,
      isBusy: false,
      busyMsg: "",
      isCheckingForUpdates: false,
      checkingForUpdatesMode: "icon",
      lastUpdatedTicks: "0",
      isAutoRefresh: true,

      showModal: false,
      modalType: null,
      alertIconType: null,
      alertTitle: "",
      alertMessage: "",
      hasOtherLocalStoredObsUsers: false,
      otherLocalStoredObsUsers: "",
      quarantineCount: 0
    }

    this.checkForUpdatedReceipts = this.checkForUpdatedReceipts.bind(this);

    this.onTimerTrigger = this.onTimerTrigger.bind(this);
    this.refreshGridData = this.refreshGridData.bind(this);
    this.busyOn = this.busyOn.bind(this);
    this.busyOff = this.busyOff.bind(this);
    this.showAlertDialog = this.showAlertDialog.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onGridMenuCloseRequest = this.onGridMenuCloseRequest.bind(this);
    this.onGridMenuRequest = this.onGridMenuRequest.bind(this);
    this.onDetailViewRequest = this.onDetailViewRequest.bind(this);
    this.onRepostTagRequest = this.onRepostTagRequest.bind(this);
    this.onReprintTagsRequest = this.onReprintTagsRequest.bind(this);
    this.onResendNotificationsRequest = this.onResendNotificationsRequest.bind(this);
    this.onVoidRequest = this.onVoidRequest.bind(this);
    this.onMarkCompleteRequest = this.onMarkCompleteRequest.bind(this);
    this.onLogViewRequest = this.onLogViewRequest.bind(this);
    this.onSaveLayoutRequest = this.onSaveLayoutRequest.bind(this);
    this.onResetLayoutRequest = this.onResetLayoutRequest.bind(this);
    this.onRestoreLayoutRequest = this.onRestoreLayoutRequest.bind(this);
    this.onCloseMenuRequest = this.onCloseMenuRequest.bind(this);

    this.onCheckingForUpdatesToggle = this.onCheckingForUpdatesToggle.bind(this);

    this.toggleAutoRefresh = this.toggleAutoRefresh.bind(this);


    this.columnDefs = 
    [
         //Cant include nested values because access isnt guaranteed
        {headerName: "Status", field: "status.flowStatus", sortable: true, filter: true, resizable: true, maxWidth: 200, cellStyle: this.lineStatusStyle},
        {headerName: "Date-Time", field: "receiveDateTime", sortable: true, filter: true, resizable: true, maxWidth: 120, cellRenderer: function(params) {return moment(params.value).format("YY-MM-DD HH:mm")}},
        {headerName: "Block Name", field: "lines.0.blockName", sortable: false, filter: true, resizable: true, maxWidth: 250},
        // {headerName: "Grower", field: "lines.0.labelName", sortable: false, filter: true, resizable: true, maxWidth: 120},
         {headerName: "Total Qty", field: "tagUnitQty", sortable: true, filter: true, resizable: true,maxWidth: 90},
         {headerName: "Pallets", field: "tagPalletQty", sortable: true, filter: true, resizable: true,maxWidth: 90},
        // {headerName: "Status", field: "status.flowStatus", sortable: true, filter: true, resizable: true, maxWidth: 150, cellStyle: this.lineStatusStyle},
        // {headerName: "Transaction", field: "transactionId", sortable: false, filter: true, resizable: true, minWidth:300, maxWidth: 300},
        {headerName: "Receipt ID", field: "tagId", sortable: true, filter: true, resizable: true, maxWidth: 120},
        // {headerName: "Total Units", field: "tagUnitQty", sortable: false, filter: false, resizable: true, maxWidth: 120, type: "numericColumn"},
        {headerName: "Comment", field: "lot", sortable: true, filter: true, resizable: true, maxWidth: 200},
        {headerName: "Reference", field: "reference", sortable: true, filter: true, resizable: true, maxWidth: 250},
        {headerName: "Warehouse", field: "warehouseName", sortable: true, filter: true, resizable: true, maxWidth: 250},
        {headerName: "Location", field: "sublocationName", sortable: true, filter: true, resizable: true, maxWidth: 250}
  
    ];
  }

  async componentDidMount() 
  {
    await this.refreshGridData();

    var lastTicksResult = ((this.props.userSession) && (this.props.userSession.locationInfo) && (this.props.userSession.locationInfo.warehouse) && (this.props.userSession.locationInfo.warehouse.id)) ?
      await this.coreService.fetchLastReceiptsUpdateTicks(this.props.userSession.gcid, this.props.userSession.locationInfo.warehouse.id, this.props.userSession.token)
    : {hasError: true, dataResult: "3155378975999999999"};
    //if (this.props.isConnected) {
        this.setState({
        lastUpdatedTicks: lastTicksResult.dataResult
      });



      if ((this.syncTimer) && (this.syncTimer !==""))
      {
        console.log("clearing interval on componentdidmount...");
        clearInterval(this.syncTimer);
      }
      this.syncTimer = setInterval(() => this.onTimerTrigger(), this.delayInterval);
      console.log("Set syncTimer: " + this.syncTimer + " with delay interval " + this.delayInterval);
    //}
  }

  async componentDidUpdate(prevProps, prevState)
  {
    if (this.props.userSessionKey !== prevProps.userSessionKey)  
    {
      console.log("refreshing grid data...")
      await this.refreshGridData(this.props.gridQueryString);
    }

  }

  async componentWillUnmount()
  { 
    console.log("grid panel is unmounting...")
    console.log("Clearing syncTimer interval (id: " + this.syncTimer + ")");
    if ((this.syncTimer) && (this.syncTimer !== ""))
    {
      console.log("Clearing interval...");
      clearInterval(this.syncTimer);
    }
    //else
    //{
      // ugh! we lost the handle on the syncTimer! But we HAVE to kill it!
      console.log("Clearing interval that we've lost. Iterating through 999 intervals");
      for(var i=0; i<999; i++)
      {
        clearInterval(i);
      }
    //}
  }

  toggleAutoRefresh()
  {
    var newAutoRefresh = (!this.state.isAutoRefresh);
    console.log("Toggled Autorefresh...");
    console.info(newAutoRefresh);
    this.setState({isAutoRefresh: newAutoRefresh});
  }

  async onTimerTrigger()
  {
    if (this.state.isBusy) return;
    if (!this.state.isAutoRefresh) return;
    await this.checkForUpdatedReceipts();
  }

  busyOn(msg) {
    this.setState({ isBusy: true, busyMsg: msg });
  }

  busyOff() {
    this.setState({ isBusy: false, busyMsg: "" });
  }

  onCheckingForUpdatesToggle()
  {
    var newStatus = (this.state.checkingForUpdatesMode === "icon") ? "text": "icon";
    this.setState({checkingForUpdatesMode: newStatus});
  }



  async refreshGridData() 
  {
    console.info("Starting Refresh Grid...");
    if (!this.state.isAutoRefresh) 
    {
      console.info("Auto-refresh is off.");
      return;
    }
    


    try 
    {
      console.info("refreshing quarantine info.");
      var gridData = [];

      this.busyOn("Fetching quarantine info...");
      
      if (this.props.userSession.uid === "")
      {
        this.props.onErrorPageRequest(["The system no longer recognizes your login information. Did you accidentally refresh the page?"]);
        return;
      }

      var remoteQuarantineResponse =  await this.coreService.fetchQuarantineReceipts(this.props.userSession.gcid, this.props.userSession.currentLocationId, moment().format(), this.props.userSession.token);
      if (remoteQuarantineResponse.hasError) {
        let msgs = ["There was a problem fetching remote quarantine info. "];
        msgs.push(remoteQuarantineResponse.msgs);
        this.props.onErrorPageRequest(msgs);
        return;
      }
      var quarantineCount = remoteQuarantineResponse.dataResult.length;


      this.busyOn("Refreshing locally-stored receipts...");
      var localDataResponse = await this.localDbService.fetchAllReceipts();
      if (localDataResponse.hasError) {
        let msgs = ["There was a problem fetching locally-stored receipts. "];
        msgs.push(localDataResponse.msgs);
        this.props.onErrorPageRequest(msgs);
        return;
      }

      console.log("refreshing today's receipts...");
      this.busyOn("Fetching today's receipts...")
      var remoteDataResponse = await this.coreService.fetchTodaysReceipts(this.props.userSession.gcid, this.props.userSession.currentLocationId, moment().format(), this.props.userSession.token);
      if (remoteDataResponse.hasError) {
        let msgs = ["There was a problem fetching today's receipts. "];
        msgs.push(remoteDataResponse.msgs);
        this.props.onErrorPageRequest(msgs);
        return;
      }

      this.busyOn("prepping data...");
      gridData = remoteDataResponse.dataResult;
      this.busyOn("Found " + gridData.length + " historical receipts using your filter.");
      this.props.onUpdateCurrentReceipt(null);
      this.setState({
        quarantineCount: quarantineCount,
        gridData: gridData
      });
    }
    catch (err) {
      let msgs = ["There was a problem refreshing observation data. "];
      msgs.push(err.message);
      this.props.onErrorPageRequest(msgs);
      return;
    }
    finally {
      this.busyOff();
    }
  }



  async checkForUpdatedReceipts()
  {
    console.log("checkForUpdatedReceipts...");
    if (this.state.isCheckingForUpdates)
    {
      // don't kick off again!
      console.log("isCheckingForUpdates is already running. Returning without running.");
      return;
    }
    this.setState({isCheckingForUpdates: true});
    try
    {
      var lastTicksResult = ((this.props.userSession) && (this.props.userSession.locationInfo) && (this.props.userSession.locationInfo.warehouse) && (this.props.userSession.locationInfo.warehouse.id)) ?
        await this.coreService.fetchLastReceiptsUpdateTicks(this.props.userSession.gcid, this.props.userSession.locationInfo.warehouse.id, this.props.userSession.token)
        : {hasError: true};

        //var receiptsStatusResult = await this.coreService.fetchTodaysReceiptsStatus(this.props.userSession.gcid, this.props.userSession.currentLocationId, moment().format(), this.props.userSession.token);
      if (lastTicksResult.hasError)
      {
        //yikes! Let's not fail, though. Let's just assume it SHOULD BE refreshed. Better than not refreshing at all, isn't it?
        lastTicksResult.dataResult = "3155378975999999999"; // maximum number of ticks in dotnetcore
        
        //let msgs = ["There was a problem fetching the last time this location's receipts were updated... "];
        //msgs.push(lastTicksResult.msgs);
        //this.props.onErrorPageRequest(msgs);
        //return;
      }
      var lastUpdatedTicks = lastTicksResult.dataResult;
      console.log("Last updated tick " + lastUpdatedTicks);
      console.log("State Tick " + this.state.lastUpdatedTicks);
      if (lastUpdatedTicks > this.state.lastUpdatedTicks)
      {
        this.setState({"lastUpdatedTicks": lastUpdatedTicks});
        // trigger a grid refresh
        this.props.onRefreshUserSessionKey();
      }
    }
    finally
    {
      this.setState({isCheckingForUpdates: false});
    }
  }

  onSaveLayoutRequest()
  {
    this.setState({showModal: false});
    var newGridColState = this.gridColumnApi.getColumnState();
    this.localStorageService.saveHistoryGridLayout(this.props.userSession.gcid, this.props.userSession.uid, newGridColState);
  }

  onResetLayoutRequest()
  {
    this.setState({showModal: false});
    this.gridColumnApi.resetColumnState();
    this.gridColumnApi.resetColumnGroupState();
    this.gridApi.setSortModel(null);
    this.gridApi.setFilterModel(null);
  }

  onRestoreLayoutRequest()
  {
    this.setState({showModal: false});
    if (this.localStorageService.hasHistoryGridLayout(this.props.userSession.gcid, this.props.userSession.uid))
    {
      var savedGridLayout = this.localStorageService.getHistoryGridLayout(this.props.userSession.gcid, this.props.userSession.uid);
      this.gridColumnApi.setColumnState(savedGridLayout);
    }
    else
    {
      alert("Please save a layout first!");
    }
  }




  // agGrid events



  onEditGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };


  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.localStorageService.hasHistoryGridLayout(this.props.userSession.gcid, this.props.userSession.uid))
    {
      var savedGridLayout = this.localStorageService.getHistoryGridLayout(this.props.userSession.gcid, this.props.userSession.uid);
      this.gridColumnApi.setColumnState(savedGridLayout);
    }
  };

  onSelectionChanged() {
    var selectedNodes = this.gridApi.getSelectedNodes();
    console.info(selectedNodes);
    var rowData = selectedNodes[0].data;
    console.info(rowData);
    this.setState({ selectedRow: rowData });
    this.props.onUpdateCurrentReceipt(rowData);
  }

  lineStatusStyle(params)
  {
    if (!params.data.status) return {'background-color': 'white'};

    if (params.data.status.flowStatus === MsaReceiptStatusType.POSTEDTOMRA){  //   'POSTED-TO-MRA'){
      return {'background-color': '#7FFF3A'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.TOQA){  // 'TO-QA'){
      return {'background-color': '#FFB641'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.AWAITINGQA){ // 'AWAITING-QA'){
        return {'background-color': '#FFE750'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.RECEIVEDQA){ // 'RECEIVED-QA'){
        return {'background-color': '#FFB641'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.AWAITDISPOSITION){ //'AWAIT-DISPOSITION'){
        return {'background-color': '#FFE750'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.VOIDED){ //'VOID'){
      return {'background-color': '#B3B3B3'}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.TOAUTOPILOT){ // 'TO-AUTOPILOT'){
      return {'background-color': '#7FFF3A'}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.TOPRINTERGNOME){ 
      return {'background-color': '#7FFF3A'}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.POSTEDTOFAMOUS){ //"POSTED-TO-FAMOUS"){
      return {'background-color': "#7FFF3A"}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.FAMOUSTAGSPRINTED){ //"FAMOUS-TAGS-PRINTED"){
      return {'background-color': "#7FFF3A"}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.AWAITINGFAMOUSRETRY){ // "AWAITING-FAMOUS-RETRY"){
      return {'background-color': "#FF5E00"}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.TAGPRINTERROR){ //"AWAITING-TAGPRINT-RETRY"){
      return {'background-color': "#FF5E00"}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.COMPLETE){ 
      return {'background-color': "#7FFF3A"}
    }
    else {
      return {'background-color': '#B3B3B3'}
    }
  }

  // end agGrid events

  showAlertDialog(title, message, type) {  //error warning info
    this.setState({ alertTitle: title, alertMessage: message, alertIconType: type });
    this.setState({ showModal: true, modalType: "alert" });
  }



  onDetailViewRequest() {
    console.log("Detail View Request...");
    this.setState({ showModal: false });
    if (!this.state.selectedRow) {
      this.showAlertDialog("Select a Receipt", "Please select an receipt to view its details!", "error");
      return;
    }
    this.setState({ showModal: true, modalType: "detail" });
  }

  async onRepostTagRequest()
  {
    console.log("Repost Receipt to Famous Request...");
    this.setState({showModal: false});
    if (!this.state.selectedRow) {
      this.showAlertDialog("Repost Tag to Famous", "Please select an receipt to repost .", "error");
      return;
    }
    this.busyOn("Saving repost tag request...");
    try
    {
      var repostResult = await this.coreService.postTagRepostRequest(this.props.userSession.gcid, this.state.selectedRow,this.props.userSession.uid, this.props.userSession.token);
      if (repostResult.hasError)
      {
        this.busyOff();
        this.showAlertDialog("Tag Repost Request Error", "There was an error trying to repost your tag. " + repostResult.messages.join(' '), "error");
      }
    }
    finally
    {
      this.busyOff();
    }
  }

  async onReprintTagsRequest()
  {
    console.log("Reprint Tags Request...");
    this.setState({showModal: false});
    if (!this.state.selectedRow) {
      this.showAlertDialog("Reprint Tags", "Please select an receipt to reprint its pallet tags.", "error");
      return;
    }
    this.busyOn("Posting receipt tags reprint request...");
    try
    {
      //var zebraPrintService = new ZebraPrintService();
      //await zebraPrintService.printBarCode(this.state.selectedRow.tagId);
      // "reprinting" a tag is basically just reposting the receipt. 
      var repostResult = await this.coreService.postTagReprintRequest(this.props.userSession.gcid, this.state.selectedRow,this.props.userSession.uid, this.props.userSession.token);
      if (repostResult.hasError)
      {
        this.busyOff();
        this.showAlertDialog("Reprint Request Error", "There was an error performing your tag reprint request. " + repostResult.messages.join(' '), "error");
      }
    }
    finally
    {
      this.busyOff();
    }
  }

  async onResendNotificationsRequest()
  {
    this.setState({showModal: false});
    if (!this.state.selectedRow) {
      this.showAlertDialog("Resend Notifications", "Please select an receipt to resend its notifications.", "error");
      return;
    }
    this.busyOn("Posting receipt notifications resend request...");
    try
    {
      var resendResult = await this.coreService.postNotificationResendRequest(this.props.userSession.gcid, this.state.selectedRow, this.props.userSession.token);
      if (resendResult.hasError)
      {
        this.busyOff();
        this.showAlertDialog("Notification Resend Request Error", "There was an error performing your notification resend request. " + resendResult.messages.join(' '), "error");
      }
    }
    finally
    {
      this.busyOff();
    }
  }


  async onMarkCompleteRequest()
  {
    console.log("Mark Receipt Complete Request...");
    this.setState({showModal: false});
    if (!this.state.selectedRow) {
      this.showAlertDialog("Mark Complete", "Please select an receipt to mark this receipt complete.", "error");
      return;
    }
    this.busyOn("Posting mark complete request...");
    try
    {
      var repostResult = await this.coreService.postMarkCompleteRequest(this.props.userSession.gcid, this.state.selectedRow,this.props.userSession.uid, this.props.userSession.token);
      if (repostResult.hasError)
      {
        this.busyOff();
        this.showAlertDialog("Mark Complete Request Error", "There was an error performing your request to mark receipt complete. " + repostResult.messages.join(' '), "error");
      }
    }
    finally
    {
      this.busyOff();
    }
  }

  async onVoidRequest()
  {
    console.log("Void Receipt Request...");
    this.setState({showModal: false});
    if (!this.state.selectedRow) 
    {
      this.showAlertDialog("Void Receipt", "Please select an receipt to void.", "error");
      return;
    }
    this.setState({isBusy: true, busyMsg: "Requesting to void receipt " + this.state.selectedRow.tagId});
    try
    {
      var voidEvent = new ReceiptVoidEvent
      (
          this.state.selectedRow.transactionId, this.state.selectedRow.tagId, this.state.selectedRow.gcid,
          "USERREQUEST", moment().format(), this.props.userSession.uid
      );
      var voidRequestResult = await this.coreService.postVoid(this.props.userSession.gcid, voidEvent);
      if (voidRequestResult.hasError)
      {
        this.showAlertDialog("Void Receipt", "There was a problem making your void request. " + voidRequestResult.messages.join(' '), "error");
      }
      toast.success("Receipt has been voided.");
      this.refreshGridData();
    }
    finally
    {
      this.setState({isBusy: false, busyMsg: ""});
    }
  }


  onLogViewRequest()
  {
    console.log("Log View Request...");
    this.setState({ showModal: false });
    if (!this.state.selectedRow) {
      this.showAlertDialog("Select a Receipt", "Please select an receipt to view its log", "error");
      return;
    }
    this.setState({ showModal: true, modalType: "log" });
  }

  onCloseMenuRequest() {
    this.setState({ showModal: false, modalType: "" });
  }


  onGridMenuRequest(e) {
    if (e.target.id === "gridOptions") {
      console.log("gridded to grid opts")
      this.setState({ showModal: true, modalType: "gridmenu" });
    } else if (e.target.id === "gridLayout") {
      console.log("grid layout");
      this.setState({showModal: true, modalType: "gridlayout"});
      // TBD
    }
    else {
      console.log("didnt do anything")
      this.setState({
        showModal: true,
        modalType: "none"
      });
    }
  }

  onGridMenuCloseRequest() {
    this.setState({ showModal: false });
  }

  render() 
  {

    var checkingForUpdatesSpan =  (this.state.checkingForUpdatesMode==="icon") ?
        <span id="checkingIcon" key="checkingIcon" onClick={(e) => this.onCheckingForUpdatesToggle()}><FontAwesomeIcon icon={faSatelliteDish} color= {(this.state.isCheckingForUpdates) ?"green": "lightgrey"} /></span>
        : <span style={{color: "lightgrey", fontSize: "11px"}} onClick={(e)=>this.onCheckingForUpdatesToggle()}>&nbsp; delay:{this.state.refreshDelay}</span>

    var busySpan = (this.state.isBusy) ? <span id="busyIcon"><FontAwesomeIcon icon={faSyncAlt} color="green" spin /><span style={{ color: "white", fontSize: "12pt" }}> &ensp; {this.state.busyMsg}</span></span>
      : <span />;

    const gridData = this.state.gridData ? this.state.gridData : [{}];

    const quarantineLabel = (this.state.quarantineCount > 0) ? 
      this.state.quarantineCount + " in Quarantine"
      : "Nothing in Quarantine";


    const isReadOnly = (this.props.userSession.currentLocationId==="all"); 

    return (
      <div>
        {busySpan}
        <div style={{ display: "flex", flexDirection: "column" }}>

          <ReactTooltip />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

        <ModalGridMenu
          readOnly={isReadOnly}
          modalType={this.state.modalType}
          userSession={this.props.userSession}
          show={this.state.showModal}
          onHide={this.onGridMenuCloseRequest}
          onDetailViewRequest={this.onDetailViewRequest}
          onLogViewRequest={this.onLogViewRequest}
          onRepostTagRequest={this.onRepostTagRequest}
          onReprintTagsRequest={this.onReprintTagsRequest}
          onResendNotificationsRequest={this.onResendNotificationsRequest}
          onVoidRequest={this.onVoidRequest}
          onMarkCompleteRequest={this.onMarkCompleteRequest}
          onQuarantinePageRequest = {this.props.onQuarantinePageRequest}
          onAddReceiptPageRequest = {this.props.onAddReceiptPageRequest}
          onSaveLayoutRequest = {this.onSaveLayoutRequest}
          onResetLayoutRequest = {this.onResetLayoutRequest}
          onRestoreLayoutRequest = {this.onRestoreLayoutRequest}
          onCloseMenuRequest={this.onCloseMenuRequest}
          gridQueryString={this.props.gridQueryString}
          currentReceipt = {this.props.currentReceipt}
          lastReceipt = {this.props.lastReceipt}
          alertIconType = {this.state.alertIconType}
          alertTitle = {this.state.alertTitle}
          alertMessage = {this.state.alertMessage}
        />

        <div id="gridselectionui">
          <div id="gridselectionsubui">
            <Button
              id="gridOptions"
              key="gridMenu"
              size="sm"
              variant="outline-info"
              onClick={(e) => this.onGridMenuRequest(e)}
              style={{ borderTopRightRadius: "2px !important" }}
            >
              <FontAwesomeIcon icon={faBars} />
              &nbsp;Grid Menu
            </Button>


            <Button
              key="addreceiptbutton"
              size="sm"
              variant="outline-info"
              onClick={(e) => this.props.onAddReceiptPageRequest(e)}
              style={{ borderTopRightRadius: "2px !important"}}
              disabled = {isReadOnly}
            >
              <FontAwesomeIcon icon={faPlusCircle} />
              &nbsp;Add Receipt
            </Button>

            <Button
              key="quarantineButton"
              size="sm"
              variant="outline-info"
              disabled={(this.state.quarantineCount<1)}
              onClick={(e) => this.props.onQuarantinePageRequest(e)}
              style={{ borderTopRightRadius: "2px !important", borderColor: (this.state.quarantineCount > 0) ? "red": "green" }}
            >
              <FontAwesomeIcon icon={faBars} />
              &nbsp;{quarantineLabel}
            </Button>

            <Button
              key="printTagTestButton"
              size="sm"
              variant="outline-info"
              disabled={isReadOnly}
              onClick={(e) => this.props.onPrintTagTestRequest(e)}
              style={{ borderTopRightRadius: "2px !important"}}
            >
              <FontAwesomeIcon icon={faPrint} />
              &nbsp;Print Test Tag
            </Button>
            </div>

            <div id="gridselectionsubuiright">

            <Toggle 
            defaultChecked={this.state.isAutoRefresh}
            icons={{
              checked: <FontAwesomeIcon icon={faSyncAlt} color="white" size="sm"/>,
              unchecked: <FontAwesomeIcon icon={faSyncAlt} color="white" size="sm"/>,
            }}
            onChange= {this.toggleAutoRefresh}
          />




            <Button
              key="refreshgridbutton"
              size="sm"
              variant="outline-info"
              onClick={(e) => this.refreshGridData(e)}
            >
              <FontAwesomeIcon icon={faSyncAlt} />
              &nbsp;Refresh
            </Button>
            <Button
              id="gridLayout"
              key="gridLayout"
              size="sm"
              variant="outline-info"
              onClick={(e) => this.onGridMenuRequest(e)}
            >
              <FontAwesomeIcon icon={faBars} />
              &nbsp;Grid Options
            </Button>

            {/* status queue */}
            &nbsp;{checkingForUpdatesSpan}&nbsp;&nbsp;
            </div>

  

          </div>

          <div className="ag-theme-balham" style={{ width: "100%", height: "calc(85vh)" }}>
            <AgGridReact
              rowSelection="single"
              enableRangeSelection={true}
              pagination={true}
              columnDefs={this.columnDefs}
              rowData={gridData}
              animateRows={true}
              onGridReady={this.onGridReady}
              onSelectionChanged={this.onSelectionChanged.bind(this)}
            />
          </div>

        </div>
      </div>
    )
  }
}